import { Link, Navigate } from "react-router-dom";
import useIsDeveloper from "../useIsDeveloper";
import "./BoilerRoom.scss";

const SECTIONS = [
	{
		heading: "AI Knowledge Base",
		tools: [
			{
				title: "Transcript Backfill",
				description: "Re-extract transcripts for live course content that's missing them. Useful after AI changes or for bulk repair.",
				path: "/transcript-backfill"
			},
			{
				title: "RAG Index Backfill",
				description: "Re-build the RAG search index from the durable blob store. Use after a schema change or to populate a fresh environment.",
				path: "/rag-index-backfill"
			}
		]
	}
];

const BoilerRoom = () => {
	const { isLoading, isDeveloper } = useIsDeveloper();

	if (isLoading) {
		return null;
	}
	if (!isDeveloper) {
		return <Navigate to="/dashboard" replace />;
	}

	return (
		<div className="boiler-room">
			<header className="boiler-room__header">
				<h1>The Boiler Room</h1>
				<p className="boiler-room__tagline">Developer-only tools.</p>
			</header>

			{SECTIONS.map((section) => (
				<section key={section.heading} className="boiler-room__section">
					<h2>{section.heading}</h2>
					<div className="boiler-room__cards">
						{section.tools.map((tool) => (
							<Link key={tool.path} to={tool.path} className="boiler-room__card">
								<h3>{tool.title}</h3>
								<p>{tool.description}</p>
								<span className="boiler-room__card-open">Open →</span>
							</Link>
						))}
					</div>
				</section>
			))}
		</div>
	);
};

export default BoilerRoom;
